var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "49px",
    viewBox: "0 0 70 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "level") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Suitable-perspectives",
    transform: "translate(-25.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9965156,28.3282239 C75.6470008,35.8222715 75.6932347,43.9987534 73.0376505,51.5629727 L61.7112604,47.5988827 C63.4581824,42.6300085 63.4284161,37.2638023 61.6832528,32.3294844 L72.9965156,28.3282239 Z M7.1552311,27.9014579 L18.4114535,32.0604791 C16.5469954,37.1065593 16.5356149,42.584097 18.2911905,47.5981049 L6.96497607,51.5625532 C4.29671504,43.9410289 4.31375978,35.5917848 7.1552311,27.9014579 Z M55.3429894,8.5422082 C63.1488477,12.3493797 69.1290596,18.8073976 72.3659644,26.6783633 L61.2678024,31.2424404 C59.1385221,26.0648114 55.2204014,21.8336413 50.0825356,19.3277368 L55.3429894,8.5422082 Z M25.0938172,8.33176385 L30.198756,19.1917639 C25.4862463,21.406964 21.6599391,25.1357405 19.3254256,29.9222025 C19.1551473,30.271522 18.9940995,30.6237805 18.8423028,30.9787703 L7.80871934,26.2607161 C8.03833406,25.7237419 8.28158216,25.1913727 8.53930999,24.6629523 C12.0848531,17.3935117 17.9262523,11.7010069 25.0938172,8.33176385 Z M53.1953085,7.5814643 C53.9160983,7.87553949 54.6288485,8.19418136 55.3326616,8.53717307 L50.0756854,19.3243978 C49.6095762,19.0972464 49.1382458,18.8865336 48.6621926,18.6923086 L53.1953085,7.5814643 Z M51.5919939,6.97247408 L47.6062299,18.2912057 C42.2661262,16.4107483 36.4691721,16.5912366 31.272407,18.7198972 L26.7238505,7.61536508 C34.6195088,4.38120378 43.4523575,4.10619275 51.5919939,6.97247408 Z",
    id: "Combined-Shape",
    fill: "#F5F7FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1763809,20.6814835 C55.845703,23.5403197 62.1773528,34.5070588 59.3185165,45.1763809 C59.2027459,45.6084429 59.073679,46.0333916 58.9318741,46.4509046 L57.987718,46.121178 C58.1214744,45.7268494 58.2432723,45.3255438 58.3525907,44.9175619 C61.0684851,34.7817059 55.0534178,24.3633037 44.9175619,21.6474093 C34.7817059,18.9315149 24.3633037,24.9465822 21.6474093,35.0824381 C20.6044142,38.9749488 20.8490781,42.9091299 22.1202897,46.4327237 L21.1762318,46.76291 C19.8407478,43.0560063 19.5844205,38.9179139 20.6814835,34.8236191 C23.5403197,24.154297 34.5070588,17.8226472 45.1763809,20.6814835 Z",
    id: "Combined-Shape",
    fill: "#F5F7FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1493886,50.1807646 L66.1758015,50.976511 C65.7990753,45.3079167 63.3531582,40.0645284 59.3534904,36.1309913 L67.7677465,27.5752743 C73.8457638,33.5527972 77.575723,41.5488267 78.1493886,50.1807646 Z",
    id: "Oval",
    fill: "#29CCC7",
    fillRule: "nonzero",
    transform: "translate(68.751439, 39.275893) rotate(26.000000) translate(-68.751439, -39.275893) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBF0F5",
    cx: 40,
    cy: 40,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8886636,31.7240567 C58.0247038,31.9102235 58.0157971,32.1652783 57.867102,32.3415019 L44.773491,47.8616948 C44.6455941,48.0548255 44.4931395,48.2361123 44.316285,48.4010317 C43.1045385,49.5310036 41.2062007,49.4647122 40.0762288,48.2529657 C38.9462569,47.0412192 39.0125483,45.1428814 40.2242948,44.0129095 C40.4027531,43.8464945 40.5961032,43.7060258 40.7996976,43.5913412 L57.1899616,31.6153578 C57.4129192,31.4524329 57.7257388,31.5010991 57.8886636,31.7240567 Z",
    id: "Combined-Shape",
    fill: "#849BB3",
    transform: "translate(48.627621, 40.363003) rotate(45.000000) translate(-48.627621, -40.363003) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBF0F5",
    cx: 40,
    cy: 40,
    r: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttract);
export default __webpack_public_path__ + "static/media/attract.d51b3d8a9aa6c288ea93345df9491093.svg";
export { ForwardRef as ReactComponent };